export const grid = `
display: grid;
`;
